'use strict';

var SOUNDCLOUD_USER_RE = /http(s)?:\/\/soundcloud.com\/([^\/]+).*/i,
    SOUNDCLOUD_USER_URL = 'http$1://soundcloud.com/$2';

/**
 * Parse track(list) url to extract user URL
 * because we don't save it (at least we don't yet).
 */
function extractSoundCloudUserUrl(trackOrPlaylistUrl) {
  return trackOrPlaylistUrl.replace(SOUNDCLOUD_USER_RE, SOUNDCLOUD_USER_URL);
}

module.exports = extractSoundCloudUserUrl;


/** WEBPACK FOOTER **
 ** ./utils/extractSoundCloudUserUrl.js
 **/